<template>
  <div>
    <MemberLayout activeLink="member">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <FordaysBannerLogo />
          </div>
          <div class="col-6">
            <router-link to="/member/record-list" class="member-main-btn">
              <i class="fas fa-th-list"></i>
              <span class="member-main-btn-text">訂購紀錄查詢</span>
            </router-link>
          </div>
          <div class="col-6">
            <router-link to="/member/point-card" class="member-main-btn">
              <i class="fas fa-star"></i>
              <span class="member-main-btn-text">集點卡</span>
            </router-link>
          </div>
          <div class="col-6">
            <router-link to="/member/hierarchy" class="member-main-btn">
              <i class="fas fa-sitemap"></i>
              <span class="member-main-btn-text">組織圖</span>
            </router-link>
          </div>
          <div class="col-6">
            <router-link to="/member/bonus-list" class="member-main-btn">
              <i class="fas fa-money-bill"></i>
              <span class="member-main-btn-text">獎金查詢</span>
            </router-link>
          </div>
          <div class="col-6">
            <router-link to="/member/account-settings" class="member-main-btn">
              <i class="fas fa-cog"></i>
              <span class="member-main-btn-text">帳號設定</span>
            </router-link>
          </div>
          <div class="col-6">
            <button class="member-main-btn" @click="logout">
              <i class="fas fa-sign-out-alt"></i>
              <span class="member-main-btn-text">登出</span>
            </button>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import FordaysBannerLogo from "../../components/member/FordaysBannerLogo";
import { mapActions } from "vuex";
import firebase from "../../api/firebase";
export default {
  name: "MemberScreen",
  components: {
    MemberLayout,
    FordaysBannerLogo,
  },
  methods: {
    ...mapActions(["singOutAuth"]),
    logout() {
      const vm = this;
      firebase
        .auth()
        .signOut()
        .then(() => {
          vm.singOutAuth();
          vm.$router.push("/login");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>